var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.messages.length
    ? _c(
        "div",
        { staticClass: "flash-messages__container" },
        [
          _c(
            "transition-group",
            { attrs: { name: "fade" } },
            [
              _vm._l(_vm.messages, function(message, index) {
                return [
                  _c("FlashMessage", {
                    key: index,
                    attrs: { message: message }
                  })
                ]
              })
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }